export default {
  default: 'Something went wrong...',
  lineNotEmpty: 'This line is not empty',
  JSONNotValid: 'Invalid JSON',
  versionNotFound: 'Unable to get application version',
  statsRequestProblem: 'An error occurred while retrieving stats data',
  statsWrongEditionError: "Stats widgets are not available with 'community' edition",
  socketConnectionProblem: 'Problem with connection to socket server',
  socketConnectionRoomNotFound: 'Socket room not found. Please reload page or contact admin',
  socketConnectionRoomBadRequest: 'Bad request to join in socket room',
  socketConnectionRoomInternalServerError: 'Websocket connection is broken. Please reload page or contact admin',
  endDateLessOrEqualStartDate: 'End date should be after start date',
  unknownWidgetType: 'Unknown widget type: {type}',
  unique: 'Field must be unique',
  codeEditorProblem: 'Problem with code-editor',
  triggerMustNotUsed: '{field} trigger must not be used | {field} triggers must not be used',
  invalid: 'Invalid',
  invalidNumberFormat: 'Invalid number format',
};
